import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, euro, API } from "@/lib/api";
import { Download, ShieldAlert, CheckCircle2, KeyRound, Copy } from "lucide-react";
import { toast } from "sonner";

export default function DownloadPage() {
  const { order, token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { api.get(`/orders/${order}`).then((r) => setData(r.data)).catch(() => setErr(true)); }, [order]);

  const valid = data && data.payment_status === "paid" && data.download_enabled && data.download_token === token;
  const url = `${API}/download/${order}/${token}`;

  return (
    <div className="max-w-xl mx-auto px-4 py-20 sm:py-28">
      <div className="tactical-card p-8 sm:p-10 text-center" data-testid="download-page">
        {valid ? (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto" />
            <h1 className="font-display text-2xl font-bold text-white mt-6">Your download is ready</h1>
            <div className="bg-[#0A0E1A] border border-[#1E2F4D] rounded-xl p-5 mt-6 text-left space-y-2 text-sm">
              <div className="flex justify-between"><span className="text-slate-500">Order</span><span className="font-mono text-cyan-400">{data.order_number}</span></div>
              <div className="flex justify-between"><span className="text-slate-500">Product</span><span className="text-slate-200">{data.product_title}</span></div>
              <div className="flex justify-between"><span className="text-slate-500">Amount</span><span className="text-slate-200">{euro(data.amount)}</span></div>
            </div>
            {data.license_key && (
              <div className="bg-[#0A0E1A] border border-[#2563EB] rounded-xl p-5 mt-4 text-left" data-testid="download-license-block">
                <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-2"><KeyRound className="w-3.5 h-3.5 text-cyan-400" /> License key</div>
                <button onClick={() => { navigator.clipboard.writeText(data.license_key); toast.success("Copied"); }} className="w-full text-left font-mono text-white text-lg flex items-center justify-between hover:text-cyan-400">
                  {data.license_key} <Copy className="w-4 h-4 shrink-0" />
                </button>
              </div>
            )}
            <a href={url} data-testid="secure-download-btn"
              className="w-full mt-7 inline-flex items-center justify-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] btn-glow text-white font-semibold px-6 py-4 rounded-full text-lg">
              <Download className="w-6 h-6" /> Download Product
            </a>
            {data.download_token_expires_at && <p className="mt-3 text-xs text-slate-500">{typeof data.downloads_remaining === "number" && <span data-testid="download-remaining">{data.downloads_remaining} of {data.download_limit} downloads remaining · </span>}Link expires {new Date(data.download_token_expires_at).toLocaleDateString()}.</p>}
          </>
        ) : (
          <>
            <ShieldAlert className="w-14 h-14 text-rose-400 mx-auto" />
            <h1 className="font-display text-2xl font-bold text-white mt-6">Download unavailable</h1>
            <p className="text-slate-400 mt-2">
              {err ? "This download link is invalid." : "This order is not paid, the link is invalid, or downloads have been disabled. If you believe this is an error, contact support."}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
